import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <h2>About Daksh Ravitaj</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              At Daksh Ravitaj, we bridge the ancient wisdom of Ayurveda with modern global wellness needs. 
              Our commitment to quality and authenticity makes us a trusted name in herbal product exports.
            </p>
            <div className="vision-mission">
              <div className="vision">
                <h3>Our Vision</h3>
                <p>To be the world's most trusted source of authentic Ayurvedic products, bringing India's natural wellness heritage to global markets.</p>
              </div>
              <div className="mission">
                <h3>Our Mission</h3>
                <p>To provide premium quality Ayurvedic products while maintaining the highest standards of sourcing, processing, and export compliance.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 